<div class="col-12 p-0 rounded border border-secondary commentBubble">
	<div class="col-12 flex p-0">
		<div class="col-12 flex p-0">
			<div style="text-align:left" class="col-11 pb-0">
				<label><strong> Plate : </strong>{{selectedPlateID}}</label>
			</div>
			<div class="col-1 pb-0">
				<button *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
					class="float-right btn btn-outline-secondary border-0 p-0"
					(click)="setBeadchipDisplay('showPlateCommentList',false)"><em
						class="fa fa-window-minimize"></em></button>
				<button *ngIf="!beadChipCommentsDisplayMap.get('showPlateCommentList')" type="button"
					class="float-right btn btn-outline-secondary border-0 p-0"
					(click)="setBeadchipDisplay('showPlateCommentList',true)"><em
						class=" fa fa-window-maximize"></em></button>
			</div>
		</div>
	</div>
	<div *ngIf="beadChipCommentsDisplayMap.get('showPlateCommentList')">
		<div *ngFor="let comment of plateCommentList">
			<div class="col-12 p-0 commentBubbleSection">
				<div style="text-align:left" class="col-12 flex commentPUIDDate">
					<label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}} | {{comment.status}}</label>
				</div>
			</div>
			<div style="text-align:left" class="col-12 flex commentPUIDDate font-weight-bold">
				<p><strong>{{comment.comment}}</strong></p>
			</div>
		</div>
	</div>
</div>
<div *ngFor="let beadchip of beadChipCommentsMap | keyvalue">
	<div class="col-12 flex p-0 rounded border border-secondary commentBubble beadChipHeader">
		<div class="col-12 flex p-0">
			<div style="text-align:left" class="col-11 pb-0">
				<label><strong>BeadChip : </strong> {{beadchip.key}}</label>
			</div>
			<div class="col-1 pb-0">
				<button *ngIf="beadChipCommentsDisplayMap.get(beadchip.key)" type="button"
					class="float-right btn btn-outline-secondary border-0 p-0"
					(click)="setBeadchipDisplay(beadchip.key,false)"><em class="fa fa-window-minimize"></em></button>
				<button *ngIf="!beadChipCommentsDisplayMap.get(beadchip.key)" type="button"
					class="float-right btn btn-outline-secondary border-0 p-0"
					(click)="setBeadchipDisplay(beadchip.key,true)"><em class="fa fa-window-maximize"></em></button>
			</div>
		</div>
		<div *ngIf="beadChipCommentsDisplayMap.get(beadchip.key)">
			<div *ngFor="let comment of beadchip.value">
				<div class="col-12 flex p-0 commentBubbleSection">
					<div style="text-align:left" class="col-12 flex commentPUIDDate">
						<label>{{comment.puid}} | {{convertUtcToLocal(comment.timeStamp) | date: 'dd.MM.yy HH:mm'}} |
							{{comment.beadchipstatus}}</label>
					</div>
					<div style="text-align:left" class="col-12 flex commentPUIDDate font-weight-bold">
						<p>{{comment.comment}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="notExtractionAndQcScan()" class="col-12 flex" id="commentTextAreDiv">
	<textarea row=3 pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
		[(ngModel)]="newComment" [disabled]="disableInput"></textarea>
</div>

<div *ngIf="extractionAndQcScan()" class="col-12 flex" id="extractionCommentTextAreDiv">
	<textarea row=3 pInputTextarea class="extractionComment" placeholder="Add new comment here..."
		[(ngModel)]="newComment" [disabled]="disableInput"></textarea>
</div>

<div style="text-align:left" class="col-12 flex addCommentButton">
	<button *ngIf="notExtractionAndQcScan()" pButton label="Add Comment" style="height: 2rem; width: 10rem;"
		[disabled]="!(newComment != null && newComment.trim() != '') || disableInput" (click)="saveComment()"></button>

	<button class="buttonHeight" *ngIf="extractionAndQcScan()" pButton label="Add Comment"
		[disabled]="!(newComment != null && newComment.trim() != '' && selectedPlateID != '') || disableInput"
		(click)="saveComment()"></button>
	<button class="buttonHeight" *ngIf="extractionAndQcScan()" type="button" pButton label="Add comments for multiple plates"
		[disabled]="!(newComment != null && newComment.trim() != '') || disableInput"
		(click)="toggleMultiCommentsPopup()"></button>
	
	<input type="checkbox" style="transform : scale(1.7)" class="ml-2 mr-2" [(ngModel)]="updateMultiPlateCommentsCheckBox" *ngIf="multiPlateIdList.length != 0"/> <label *ngIf="multiPlateIdList.length != 0">Add comment to multiple plates</label>
</div>


<p-dialog appendTo="body" header="Add plates" [(visible)]="toggleMultiComments" (onHide)="closePopup()" [modal]="true"
	position="top" [style.width]="'300px'">
	<div class="content-in-multi-update-popup">
		<table id="scanTable" aria-describedby="View Plates" class="table">
			<thead style="display: none;">
				<th></th>
			</thead>
			<tr>
				<input pInputText name="plateId" [(ngModel)]="enteredPlateId" id="popup-plateid"
					(keydown.enter)="checkPlate()" placeholder="Enter PlateID" />
			</tr>
			<tr *ngFor="let plate of multiUpdatePlateList; let myIndex=index;">
				<input pInputText name="plateId" [value]="plate" id="plateid" readonly />
				<button pButton icon="fa fa-times-circle" class="removePopInput removePlates"
					(click)="deleteValue(myIndex)"></button>
			</tr>
		</table>
		<div>
			<button [disabled]="multiUpdatePlateList.length==0" (click)="saveMultiCommentStatus()" pButton
				class="theme-button labelButton" type="button" label="Add comment"></button>
		</div>
	</div>
</p-dialog>